import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function WhoIsItFor() {
  const cards = [{
    icon: '🏫',
    title: 'Profesores con experiencia',
    description: 'Sabés todo sobre LSA pero armar clases te consume horas que no tenés. Este sistema te da el material listo, progresivo y organizado para que te enfoques en enseñar — no en producir contenido.',
    bullets: ['Material estructurado por nivel y tema', 'Listo para usar con tus alumnos desde el día uno']
  }, {
    icon: '🌱',
    title: 'Profesores que recién arrancan',
    description: 'Estás empezando como profesor de LSA y no sabés cómo organizar las clases, qué dar primero ni cómo hacer que tus alumnos progresen. Este sistema te da la estructura completa para arrancar con confianza.',
    bullets: ['Progresión didáctica clara de cero a avanzado', 'Errores frecuentes y cómo explicarlos en el aula']
  }, {
    icon: '📋',
    title: 'Profesores independientes y talleres',
    description: 'Dás clases particulares o coordinás un taller y necesitás material profesional sin depender de otros recursos. Este sistema es tu biblioteca completa de LSA argentino.',
    bullets: ['Material 100% adaptable a tu formato de clase', 'Diccionario visual de 500+ señas para consulta rápida']
  }];
  return <section className="bg-lsa-dark text-white py-12 px-5" data-id="element-286">
      <div className="max-w-xl mx-auto" data-id="element-287">
        <h2 className="text-[28px] font-bold text-center mb-8 leading-tight" data-id="element-288">
          ¿Este sistema es para vos?
        </h2>

        <div className="flex flex-col gap-4" data-id="element-289">
          {cards.map((card, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white/5 border border-white/10 p-5 rounded-2xl" data-id="element-290">
              <div className="flex items-center gap-3 mb-3" data-id="element-291">
                <span className="text-2xl" data-id="element-292">{card.icon}</span>
                <h3 className="text-xl font-bold text-lsa-celeste" data-id="element-293">
                  {card.title}
                </h3>
              </div>

              <p className="text-white/80 text-[15px] mb-5 leading-relaxed" data-id="element-294">
                {card.description}
              </p>

              <ul className="space-y-3" data-id="element-295">
                {card.bullets.map((bullet, i) => <li key={i} className="flex items-start gap-2 text-[14px] text-white/90" data-id="element-296">
                    <Check className="text-lsa-celeste shrink-0 mt-0.5" size={18} data-id="element-297" />
                    <span data-id="element-298">{bullet}</span>
                  </li>)}
              </ul>
            </motion.div>)}
        </div>
      </div>
    </section>;
}